// src/redux/reducers/authReducer.js
const initialState = {
  token: localStorage.getItem("token") || null,
  user: JSON.parse(localStorage.getItem("userData")) || null,
  isAuthenticated: !!localStorage.getItem("token"),
  loading: false,
  error: null
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        token: action.payload.token,
        user: action.payload,
        isAuthenticated: true,
        loading: false,
        error: null
      };
    case "LOGIN_FAIL":
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        loading: false,
        error: action.payload || "Login failed"
      };
    case "LOGOUT":
      return initialState;
    case "LOGIN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null
      };
    default:
      return state;
  }
}